import supabase from "../../../shared/database/supabase";

export const deleteServiceOrderLine = async (id: string) => {
    try {
        const { data, error } = await supabase.functions.invoke("delete-service-order-line", {
            body: JSON.stringify({
                id: id,
            }),
        });

        if (error) {
            console.error("Error calling delete-service-order-line:", error);
            return { data: null, error };
        }
        return { data: data, error: null };
    } catch (err) {
        console.error("Exception in deleteServiceOrderLine:", err);
        throw err;
    }
};